import type { ReactNode } from "react";

import { article as articleData } from "shared/data";

export const MagazinesStyleTagsMap: Record<string, ReactNode> = {
  [articleData.types.explainer.entityId]: (
    <>
      Ex<span>pl</span>ainer
    </>
  ),
  [articleData.types.opinion.entityId]: (
    <>
      O<span>pi</span>n<span>i</span>on
    </>
  ),
  [articleData.types.qa.entityId]: (
    <>
      Q<span>&</span>a
    </>
  ),
  [articleData.types.recap.entityId]: <>Recap</>,
  [articleData.types.review.entityId]: (
    <>
      Re<span>v</span>iew
    </>
  ),
};
